










































import Vue from "vue";
import Field from "@/components/basic/fields/Field.vue";
import ItemList from "@/components/basic/ItemList.vue";
import { FieldInterface } from "@/types";
import { UtilityHelper } from "@/helpers/UtilityHelper";

export default Vue.extend({
  name: "AutocompleteField",
  props: {
    type: String,
    name: String,
    value: String,
    itemList: {
      type: Array,
      default: (): FieldInterface[] => [],
    },
    disabled: {
      type: [String, Boolean],
      default: false,
    },
    handlesError: {
      type: Boolean,
      default: true,
    },
    placeholder: String,
    isValidated: {
      type: Boolean,
      default: true,
    },
    handlesDataPreload: {
      type: Boolean,
      default: true,
    },
    overrideOldValue: {
      type: Boolean,
      default: false,
    },
    isStreet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayedItemList: (this as any).getItemList() as FieldInterface[],
      model: this.value,
      isListOpen: false,
      ignoreNextOpen: false,
      isClosing: false,
      isValid: false,
      isEmpty: false,
    };
  },
  methods: {
    focus(): void {
      this.$emit("focus");
      this.open();
    },
    blur(value: any): void {
      this.isEmpty = !value.length;

      UtilityHelper.sleep(60).then(() => {
        this.close();
      });
    },
    validate() {
      if (this.isValidated) {
        this.$store.dispatch("validate", {
          name: this.name,
          value: this.model,
        });
      }
      this.$emit("blur", this.model);
    },
    open(): void {
      if (this.ignoreNextOpen) {
        this.ignoreNextOpen = false;
      } else {
        this.isListOpen = true;
      }
    },
    close(): void {
      const time = Date.now();
      this.isClosing = true;

      UtilityHelper.wait(() => {
        return this.model.length > 0 || (Date.now() - time > 60 && this.model.length === 0);
      }).then(() => {
        this.isListOpen = false;
        this.isClosing = false;

        this.validate();
      });
    },

    selectValue(value: string): void {
      UtilityHelper.wait(() => this.setValue(value, true)).then(() => {
        this.close();
      });
    },

    input(value: string): void {
      this.filterItemList(value);

      if (!this.isListOpen) {
        this.open();
      }

      this.setValue(value);
    },

    async setValue(value: any, preventOpen: boolean = false): Promise<boolean> {
      this.ignoreNextOpen = preventOpen;
      this.model = value;
      this.$emit("input", this.model);

      return true;
    },

    filterItemList(value: string): void {
      UtilityHelper.wait(() => !this.isClosing).then(() => {
        this.displayedItemList = (this.list as FieldInterface[]).filter((item) => {
          return item.value.toString().toLowerCase().indexOf(value.toLowerCase()) > -1;
        });
      });
    },

    getItemList(): FieldInterface[] {
      if (this.itemList.length === 1 && ((this.model && this.model.length === 0) || this.overrideOldValue)) {
        this.setValue((this.itemList[0] as FieldInterface).value, true);
      }

      return this.itemList as FieldInterface[];
    },

    setIsValid(isValid: boolean): void {
      this.isValid = isValid;
    },
  },
  computed: {
    list(): FieldInterface[] {
      return this.getItemList();
    },
  },
  watch: {
    itemList(): void {
      this.displayedItemList = this.list;
    },
  },
  components: {
    Field,
    ItemList,
  },
});
